<template>
  <div class="ListPanel">
    <HeaderSection 
      :title="title"
      :closeLinkTo="{ name: 'home'}">
      <p>
        <!-- ... Lijst met wijken, te groeperen per gemeente. Met filter voor gemeente, en wellicht thema / partijen. -->
        Klik op een wijk om een lijst met verhalen van die wijk te bekijken, 
        of klik op de 'zoom' knop om op de wijk in te zoomen.
      </p>
    </HeaderSection>

    <List 
      :items="items" 
      :sortingBy="sortingBy"
      :groupBy="groupBy"
      type="wijken" 
      readmore="" />

    <GroeiTip />

  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';
import GroeiTip from '@/views/partials/GroeiTip';

export default {
  name: 'ListWijken',
  components: {
    List,
    HeaderSection,
    GroeiTip
  },
  data() {
    return {
      title: 'Wijken',
      sortingBy: [
        {
          key: 'name',
          label : 'A-Z'
        }
      ],
      groupBy: [
        {
          key: 'gemeenteLabel',
          label: 'Gemeente',
          dir: 'ASC',
          array: true
        }
      ]
    }
  },
  computed: {
    items() {
      let items = this.$store.getters.getWijkenList;

      items.forEach((item) => {
        item.to = { name: 'wijk-beknopt', params: { slug: item.slug } };
        return item;
      });

      return items;
    }
  }
}
</script>

<style lang="scss">

  .ListPanel {
    height: 100%;
    display: flex;
    flex-direction: column;

    .List {
      width: 100%;
      flex-grow: 1;
    }
  }

</style>
